import { createResponsiveStyles } from "@clearabee/ui-library/src/utils/createResponsiveStyles";

export const styles = {
  grid: createResponsiveStyles({
    base: {
      display: "grid",
      gridTemplateAreas: `
      'detailsform'
      'description'
      'surcharges'
      'submit'
      `,
      gridColumnGap: 36,
      gridRowGap: 18,
    },
    large: {
      gridTemplateAreas: `
        'detailsform surcharges'
        'description surcharges'
        'description submit'
      `,
      gridTemplateColumns: "repeat(2, 1fr)",
      gridRowGap: 0,
    },
  }),
};
